import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { displayName, placeholder } from './const';
import './styles.scss';

const StudentsDropdown = ({
  students,
  studentId,
  studentDisplayName,
  onChange,
  isLoading,
  stacks = [],
}) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  const studentsWithResults =
    stacks &&
    stacks.reduce((stack, option) => {
      if (!option.isNoResults && option.students) {
        stack.push(option.students.map((student) => student.id));
      }
      return stack;
    }, []);

  const options =
    students &&
    students.map((student) => ({
      ...student,
      label: `${student.firstName} ${student.lastName}`,
      value: student.id,
      disabled: !studentsWithResults.flat().includes(student.id),
    }));

  const ascendingOptions =
    options && options.sort((a, b) => a.lastName.localeCompare(b.lastName));

  const currentStudent =
    ascendingOptions &&
    ascendingOptions.length &&
    ascendingOptions.find((student) => +student.id === +studentId);

  const hasMultipleStudents = ascendingOptions && ascendingOptions.length > 1;

  const showDropdown = hasMultipleStudents && currentStudent;

  if (showDropdown) {
    return (
      <AutocompleteSelect
        className="student_results__header--student"
        options={ascendingOptions}
        value={currentStudent}
        onChange={onChange}
        disableAutoFocus
        openOnClick
        placeholder={{
          label: placeholder,
        }}
      />
    );
  }

  return (
    <div className="student_results__header--student">{studentDisplayName}</div>
  );
};

StudentsDropdown.displayName = displayName;

StudentsDropdown.props = {
  students: PropTypes.array.isRequired,
  studentId: PropTypes.string.isRequired,
  studentDisplayName: PropTypes.string.isRequired,
  studentResponses: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default StudentsDropdown;
